import { ChakraProvider } from '@chakra-ui/provider'

import { QueryClientProvider } from '@tanstack/react-query'

import { CookiesProvider } from 'react-cookie'

import { SidebarDrawerProvider } from './context/SidebarDrawerContext'
import { AuthProvider } from './context/AuthContext'
import { RegisterProvider } from './context/RegisterContext'
import { GeocodeProvider } from './context/GeocodeContext'
import { FileUploadProvider } from './context/FileUploadContext'
import { KanbanProvider } from './context/KanbanContext'

import { queryClient } from './services/react-query'

import { theme } from './styles/theme'

import { Routes } from './routes'

function App() {
  return (
    <ChakraProvider theme={theme}>
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <SidebarDrawerProvider>
            <AuthProvider>
              <RegisterProvider>
                <GeocodeProvider>
                  <FileUploadProvider>
                    <KanbanProvider>
                      <Routes />
                    </KanbanProvider>
                  </FileUploadProvider>
                </GeocodeProvider>
              </RegisterProvider>
            </AuthProvider>
          </SidebarDrawerProvider>
        </QueryClientProvider>
      </CookiesProvider>
    </ChakraProvider>
  )
}

export default App
